<template>
  <div
    class="project-analysis-item__analysis-settings"
    :class="[hasBeenSavedStyle, { expanded: isExpanded }]"
    style="display: flex; flex-direction: row; cursor: pointer"
    @click.stop="toggleContent"
  >
    <div style="display: flex; flex-direction: column">
      <div style="display: flex; flex-direction: row">
        <h2 style="font-size: 1rem; font-weight: 800; font-family: Core-Sans; margin-left: 1rem">
          <span v-if="isTextAnalysis"> <VisibleText>Text analysis</VisibleText>: </span>
          <span v-if="isDriversAnalysis"> <VisibleText>Drivers analysis</VisibleText>: </span>
          <span v-if="isOutliersAnalysis"> <VisibleText>Outliers analysis</VisibleText>: </span>
          <span v-if="isBenchmarkingAnalysis">
            <VisibleText>Benchmarking analysis</VisibleText>:
          </span>
          <span v-if="isPerformanceAnalysis"> <VisibleText>Horizontal chart</VisibleText>: </span>
          <span v-if="renamingAnalysis == false">
            {{ thisAnalysisNameRenamed }}
          </span>
        </h2>
        <div v-if="renamingAnalysis == true" @click.stop.prevent="">
          <input
            name="slide-name"
            type="text"
            style="width: 40rem; max-width: 80%"
            v-model="thisAnalysisNameRenamed"
            @change="saveAnalysisTitle"
          />
          <button
            @click="renamingAnalysis = !renamingAnalysis"
            style="background-color: transparent; border: none"
          >
            <SvgIconMeaningful icon="check" title="save title" />
          </button>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; margin-bottom: 1rem; margin-left: 1rem">
        <div
          style="display: flex; font-size: 0.9em; height: 100%; margin: auto 0"
          v-if="lastModified"
        >
          <span> <VisibleText>Last modified: </VisibleText> {{ lastModified }} </span>
        </div>
        <div v-if="isTextAnalysis && totalThemes > -1" style="margin-left: 1rem">
          <VisibleText>Themes: {{ totalThemes }}</VisibleText>
        </div>
        <div v-if="isOutliersAnalysis" style="margin-left: 1rem">
          <VisibleText>Outliers: {{ totalOutliers }}</VisibleText>
        </div>
      </div>
    </div>

    <div style="display: flex; flex-direction: row; margin: auto 0 auto auto">
      <button
        class="project-analysis-item__header-wrapper-btn"
        type="button"
        :aria-expanded="isExpanded ? 'true' : 'false'"
        style="display: flex; flex-direction: row"
      >
        <span v-if="isExpanded"><VisibleText>Close</VisibleText></span>
        <span v-else><VisibleText>Open</VisibleText></span>
        <div style="display: flex">
          <SvgIconDecorative
            :icon="isExpanded ? 'arrowUp' : 'arrowDown'"
            :class="['right', 'icon']"
            style="margin-top: 0.2em"
          />
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import SvgIconDecorative from '@/components/UI/Svg/SvgIconDecorative.vue';
import SvgIconMeaningful from '@/components/UI/Svg/SvgIconMeaningful.vue';

export default {
  name: 'AnalysisSettings',
  components: {
    SvgIconDecorative,
    SvgIconMeaningful,
  },
  props: {
    propReadOnly: {
      default: () => false,
      type: Boolean,
    },
    statusDisableActionBtns: {
      default: () => null,
      type: Boolean,
    },
    index: {
      type: Number,
      required: true,
    },
    thisAnalysisName: {
      default: () => null,
      type: String,
    },
    isDriversAnalysis: {
      default: () => null,
      type: Boolean,
    },
    filterParams: {
      default: () => null,
      type: Object,
    },
    isBenchmarkingAnalysis: {
      default: () => null,
      type: Boolean,
    },
    isTextAnalysis: {
      default: () => null,
      type: Boolean,
    },
    isOutliersAnalysis: {
      default: () => null,
      type: Boolean,
    },
    isPerformanceAnalysis: {
      default: () => null,
      type: Boolean,
    },
    isSegmented: {
      default: () => '',
      type: String,
    },
    sortOption: {
      default: () => '',
      type: String,
    },
    savedThreshold: {
      default: () => -1,
      type: Number,
    },
    viableDriversModel: {
      default: () => null,
      type: Array,
    },
    savedNodes: {
      default: () => null,
      type: Array,
    },
    contentChanged: {
      default: () => false,
      type: Boolean,
    },
    filterTop: {
      type: Number,
      default: () => 0,
    },
    lastModified: {
      type: String,
      default: () => '',
    },
    hideSave: {
      default: () => false,
      type: Boolean,
    },
    isWeighted: {
      default: () => false,
      type: Boolean,
    },
    unfilteredDate: {
      default: () => '',
      type: String,
    },
    totalThemes: {
      type: Number,
      default: () => -1,
    },
    totalOutliers: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      selectedDriversModel: '',
      isExpanded: false,
      showFilter: false,
      thisAnalysisNameRenamed: '',
      renamingAnalysis: false,
    };
  },
  methods: {
    toggleContent() {
      this.isExpanded = !this.isExpanded;
      this.$emit('toggled', this.isExpanded);
    },
    toggleRename() {
      this.renamingAnalysis = !this.renamingAnalysis;
    },
    sendNodesToReport(selectedSlide, newSlideName) {
      this.$emit('save-to-report', selectedSlide, newSlideName);
    },
    saveAnalysisTitle() {
      this.$emit('changeAnalysisTitle', this.thisAnalysisNameRenamed);
      this.toggleRename();
    },
  },
  created() {
    if (this.thisAnalysisName) {
      this.thisAnalysisNameRenamed = this.thisAnalysisName;
    }
  },
  watch: {
    expand: {
      immediate: true,
      handler: function (val) {
        this.isExpanded = val;
      },
    },
    filterTop: async function (newVal, oldVal) {
      if (oldVal && newVal) {
        if (oldVal !== newVal) {
          this.modifiedFilterTop = newVal;
        }
      }
    },
    thisAnalysisName: async function (newVal, oldVal) {
      if (oldVal && newVal) {
        if (oldVal !== newVal) {
          this.thisAnalysisNameRenamed = newVal;
        }
      }
    },
  },
  computed: {
    hasBeenSavedStyle() {
      if (this.savedNodes.length) {
        return 'project-analysis-item__analysis-settings--saved';
      }
      return '';
    },
    isFiltered() {
      if (this.filterParams) {
        if (this.filterParams.operands) {
          if (this.filterParams.operands.length) {
            return true;
          }
        }
      }
      return false;
    },
  },
};
</script>
